import React from 'react';

export const MoveDownIcon = (props) => {
  return (
    <svg viewBox='0 0 30 30' fill='currentColor' height='1em' width='1em' {...props}>
      <g id='icon/move/down' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
        <g id='bx:bx-arrow-from-top'>
          <rect id='ViewBox' x='0' y='0' width='30' height='30'></rect>
          <path
            d='M7.5,5 L22.5,5 L22.5,7.5 L7.5,7.5 L7.5,5 Z M15,25.5175 L23.38375,17.13375 L21.61625,15.36625 L16.25,20.7325 L16.25,10 L13.75,10 L13.75,20.7325 L8.38375,15.36625 L6.61625,17.13375 L15,25.5175 Z'
            id='Shape'
            fill='currentColor'
            fillRule='nonzero'
          ></path>
        </g>
      </g>
    </svg>
  );
};
